module.exports = __webpack_public_path__ + "./lichin-illustration_42ffcb466c069c00a4df423e5fb33ec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/lichin-illustration.png
// module id = 436
// module chunks = 0